import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ComponentsModule } from '@app/components/components.module';
import { HeaderModule } from '@app/components/header/header.module';
import { MenuModule } from '@app/components/menu/menu.module';
import { MotComponentsModule } from '@app/mot/components/mot-components.module';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { TotalVacationsDetailPageComponent } from '../total-vacations-detail-page/total-vacations-detail-page.component';
import { VacationsComponentsModule } from '../vacations-components.module';

const routes: Routes = [
  {
    path: '',
    component: TotalVacationsDetailPageComponent,
    data: {
      allowGoBack: true
    }
  }
];

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    RouterModule.forChild(routes),
    TranslateModule.forChild(),
    HeaderModule,
    MenuModule,
    ComponentsModule,
    MotComponentsModule,
    VacationsComponentsModule
  ],
  declarations: []
})
export class TotalVacationsDetailModule {}
